export const newsStyles = {
  main: {
    display: "flex",
    flexDirection: "column",
    background: "#FFFFFF",
    padding: "24px",
    boxShadow:
      "0px 4px 4px rgba(50, 50, 71, 0.08), 0px 4px 8px rgba(50, 50, 71, 0.06)",
    borderRadius: "10px",
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "32px",
  },
  title: {
    display: "flex",
    alignItems: "center",
    color: "#103B66",
  },
  blogLink: {
    display: "flex",
    alignItems: "center",
    color: "#21B8F9",
    cursor: "pointer",
  },
  titleIcon: {
    marginRight: "16px",
  },
  titleText: {
    fontWeight: 500,
    fontSize: "22px",
    lineHeight: "27px",
  },
  blogLinkTitle: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "20px",
    textDecorationLine: "underline",
  },
  blogLinkIcon: {
    marginLeft: "16px",
  },
  bottom: {},
};
